import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export const ReductionPlanBypassPage = () => {
  const navigate = useNavigate()

  useEffect(() => {
    // replace, or Back from the destination re-runs this redirect forwards in a loop
    navigate('/reduction-plan/targets', { replace: true })
  }, [])
  return (
    <>
    </>
  )
}
